/**
 * Navigation utility for programmatic routing outside of React components.
 *
 * Since react-router is an optional peer dependency of @cartwhl/common,
 * we use 'any' to avoid type resolution issues across package boundaries.
 * The consuming app will have proper type checking for the navigate function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let navigate: any = null;

/**
 * Initialize the navigation function. Should be called once in the root App component.
 * @param nav - The navigate function from useNavigate() hook
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setNavigate = (nav: any) => {
  navigate = nav;
};

/**
 * Navigate to a specific path programmatically from anywhere (including stores).
 * @param path - The path to navigate to (string or number for history delta)
 * @param options - Optional navigation options (replace, state, etc.)
 */
export const navigateTo = (
  path: string | number,
  options?: { replace?: boolean; state?: unknown },
) => {
  if (!navigate) {
    console.error(
      'Navigation not initialized. Make sure to call setNavigate() in your root App component.',
    );
    return;
  }
  navigate(path, options);
};

/**
 * Navigate back in history
 * @param delta - Number of steps to go back (default: -1)
 */
export const goBack = (delta: number = -1) => {
  navigateTo(delta);
};
